export default "__VITE_ASSET__DWjv9_Ab__"